import styled from 'styled-components';

export const CardPrincipalIndicatorStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => {
    return theme.colors.backgroundForm;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  border: 2px solid
    ${({ theme, isPositive }) => {
      if (isPositive) {
        return theme.colors.green;
      } else {
        return theme.colors.error;
      }
    }};
  margin: 3px 0;
  padding: 3px;
  p {
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    margin: 0;
  }
`;
